function t(a, e) {
  return a.has(e);
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_cacheHas.js
// module id = 1496
// module chunks = 67